import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { environment } from '@environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { createTokenInterceptor } from '@dvm-monorepo/frontend/interceptors/token.interceptor';
import { provideAuthentication } from '@dvm-monorepo/frontend/providers/authentication.provider';
import { routes } from '@app/app.routes';
import { provideTanStackQuery, QueryClient } from '@tanstack/angular-query-experimental';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withComponentInputBinding()),
        provideHttpClient(withInterceptors([createTokenInterceptor(environment.api)])),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: '/locales/',
                suffix: '.json'
            }),
            fallbackLang: 'en'
        }),
        provideAuthentication({
            config: {
                redirectUrl: window.location.origin,
                postLogoutRedirectUri: window.location.origin,
                responseType: 'code',
                silentRenew: true,
                useRefreshToken: true,
                autoUserInfo: true,
                renewTimeBeforeTokenExpiresInSeconds: 300,
                renewUserInfoAfterTokenRenew: true,
                ignoreNonceAfterRefresh: true,
                ...environment.authentication
            }
        }),
        provideTanStackQuery(new QueryClient())
    ]
};
